import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { ColoringScene } from './scenes/ColoringScene';
import { GAME_HEIGHT, GAME_WIDTH } from './layout';

/**
 * Creates the Phaser game. Scale.FIT preserves aspect (letterboxed) so artwork
 * never stretches; CENTER_BOTH keeps it centered. Physics is intentionally
 * absent (not needed in P0A).
 */
export function createGame(parent: string | HTMLElement): Phaser.Game {
  const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent,
    backgroundColor: '#0b3a5b',
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    // We manage drawing input ourselves via Pointer Events; keep Phaser input
    // for UI buttons only.
    input: {
      activePointers: 3,
      touch: { capture: false },
    },
    render: {
      antialias: true,
      powerPreference: 'high-performance',
    },
    scene: [BootScene, ColoringScene],
  };
  return new Phaser.Game(config);
}
